import template from './user-external-accounts.html';
import userExternalAccountsController from './user-external-accounts.controller';
import './user-external-accounts.styl';

let userExternalAccountsComponent = {
  restrict: 'E',
  bindings: {
    externalAccounts: '<'
  },
  template,
  controller: userExternalAccountsController,
  controllerAs: 'vm'
};

export default userExternalAccountsComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-external-accounts/user-external-accounts.component.js
 **/